import type { StateCreator } from 'zustand';
import type { CpmResult } from '../../types';

// ============================================================================
// CALCULATION SLICE - Manages PERT calculations and results
// ============================================================================

export interface CalculationSlice {
  // Calculation results
  criticalPath: string[];
  totalDuration: number;
  criticalNodes: string[];
  criticalEdges: string[];
  isCalculated: boolean;

  // Calculation errors/warnings
  calculationErrors: string[];
  calculationWarnings: string[];

  // Actions
  setCpmResult: (result: CpmResult) => void;
  clearCalculations: () => void;
  isCriticalNode: (nodeId: string) => boolean;
  isCriticalEdge: (edgeId: string) => boolean;
}

export const createCalculationSlice: StateCreator<CalculationSlice> = (set, get, _api) => ({
  // Initial state
  criticalPath: [],
  totalDuration: 0,
  criticalNodes: [],
  criticalEdges: [],
  isCalculated: false,
  calculationErrors: [],
  calculationWarnings: [],

  // Actions
  setCpmResult: (result) => {
    set({
      criticalPath: result.criticalPath,
      totalDuration: result.totalDuration,
      criticalNodes: result.criticalNodes,
      criticalEdges: result.criticalEdges,
      isCalculated: result.isValid,
      calculationErrors: result.errors || [],
      calculationWarnings: result.warnings || [],
    });
  },

  clearCalculations: () => {
    set({
      criticalPath: [],
      totalDuration: 0,
      criticalNodes: [],
      criticalEdges: [],
      isCalculated: false,
      calculationErrors: [],
      calculationWarnings: [],
    });
  },

  isCriticalNode: (nodeId) => get().criticalNodes.includes(nodeId),

  isCriticalEdge: (edgeId) => get().criticalEdges.includes(edgeId),
});
